import { pipe } from 'ramda';
import { setAction, setLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchDiscoveryEvent: DispatchEvent = pipe(
  setAction('discovery'),
  dispatchFrontendDashboardEvent,
);

const dispatchDiscoveryAtworkEvent: DispatchEvent = pipe(
  setLabel('atwork'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryHomeEquityEvent: DispatchEvent = pipe(
  setLabel('home_equity'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryHomeSolutionsAntecipationEvent: DispatchEvent = pipe(
  setLabel('home_solutions_antecipation'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryHomeSolutionsReformEvent: DispatchEvent = pipe(
  setLabel('home_solutions_reform'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryAutoRefinEvent: DispatchEvent = pipe(
  setLabel('auto_refin'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryCreditasAutoEvent: DispatchEvent = pipe(
  setLabel('creditas_auto'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryAutoEquityReviewEvent: DispatchEvent = pipe(
  setLabel('auto_equity_review'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryHomeEquityReviewEvent: DispatchEvent = pipe(
  setLabel('home_equity_review'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryInsuranceReviewEvent: DispatchEvent = pipe(
  setLabel('insurance'),
  dispatchDiscoveryEvent,
);

const dispatchDiscoveryPayrollLoanReviewEvent: DispatchEvent = pipe(
  setLabel('emprestimo_consignado'),
  dispatchDiscoveryEvent,
);

const dispatchDetailsButtonClickEvent: DispatchEvent = pipe(
  setLabel('details'),
  dispatchDiscoveryEvent,
);

export {
  dispatchDiscoveryAtworkEvent,
  dispatchDiscoveryHomeEquityEvent,
  dispatchDiscoveryHomeSolutionsAntecipationEvent,
  dispatchDiscoveryHomeSolutionsReformEvent,
  dispatchDiscoveryAutoRefinEvent,
  dispatchDiscoveryCreditasAutoEvent,
  dispatchDiscoveryAutoEquityReviewEvent,
  dispatchDiscoveryHomeEquityReviewEvent,
  dispatchDiscoveryInsuranceReviewEvent,
  dispatchDiscoveryPayrollLoanReviewEvent,
  dispatchDetailsButtonClickEvent,
};
